// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__9siPd","Content":"Layout_Content__2Yce7","Nav":"Layout_Nav__1Sa_o","Footer":"Layout_Footer__2suyM"};